<div class="content">
    <div fxLayout="row" fxLayoutAlign="start start" style="margin-left: 10px; " fxFlex="80">

        <ng-container *ngIf="cargando">
            <div class="course-step-content p-20" fxFlex="100">
                <ng-container>
                    <div fxLayout="column" fxLayoutAlign="space-around stretch" style="width: 100%;">
                        <div fxFlex="80">
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>{{'AVANCES.ENCUESTA.PLACE' | translate}}</mat-label>
                                <input matInput [(ngModel)]='busqueda' (keyup)="getListaEmpresas(1)" placeholder=" {{'AVANCES.ENCUESTA.PLACE' | translate}}">
                                <mat-icon matSuffix class="disabled-text">search</mat-icon>
                            </mat-form-field>

                        </div>
                        <div fxFlex="80" fxLayout="row" fxLayoutAlign="end center">
                            <h3><b>{{contadorInicio}} - {{contadorFin}}</b> {{'AVANCES.INS.INS1' | translate}} <b>{{totalEmpresas}}</b> {{'AVANCES.INS.INS2'| translate}}</h3>

                            <button mat-icon-button (click)="getListaEmpresas(prevPag)"> 
                              <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            <button mat-icon-button (click)="getListaEmpresas(nextPag)">
                              <mat-icon>keyboard_arrow_right</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start stretch" style="width: 100%;">
                        <table class="table no-wrap user-table mb-0 mat-elevation-z8" mat-table [dataSource]="dataSource">

                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef>
                                    <h2><b class="border-0 text-uppercase font-medium">{{'AVANCES.ENCUESTA.LABEL01' | translate}}</b></h2>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let filaArch" style="padding-right: 25px;">
                                    <ng-container>
                                        {{filaArch.fullName}}
                                    </ng-container>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="email">
                                <mat-header-cell *matHeaderCellDef>
                                    <h2><b class="border-0 text-uppercase font-medium">{{'AVANCES.ENCUESTA.LABEL02' | translate}}</b></h2>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let filaArch">
                                    <ng-container>
                                        {{filaArch.email}}
                                    </ng-container>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="surveyid">
                                <mat-header-cell *matHeaderCellDef>
                                    <h2><b class="border-0 text-uppercase font-medium">{{'AVANCES.ENCUESTA.LABEL03' | translate}}</b></h2>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let filaArch">
                                    <ng-container>
                                        {{filaArch.surveyKey}}
                                    </ng-container>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="acc1">
                                <mat-header-cell *matHeaderCellDef>
                                    <h2><b class="border-0 text-uppercase font-medium">{{'AVANCES.ENCUESTA.LABEL04' | translate}}</b></h2>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let filaArch">
                                    <ng-container>
                                        <button mat-icon-button aria-label="" (click)="avanceSurvey(filaArch.surveyKey)" class="btn btn-outline-info btn-circle btn-lg btn-circle ml-2">
                                            <mat-icon>rate_review</mat-icon>
                                          </button>

                                    </ng-container>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="nombresColumnasheader" class="tableHeaderCellDiv"></mat-header-row>
                            <mat-row *matRowDef="let filaArch; columns: nombresColumnasCont;" matRipple>
                            </mat-row>
                        </table>

                        <!--<button type="button" mat-button (click)="drawer.toggle()">
                          Toggle sidenav
                      </button>-->
                    </div>

                </ng-container>

            </div>
        </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxFlex="20" style="padding-top: 50px">
        <ng-container *ngIf="secondSeccion">
            <div>
                <div class="col-lg-8 col-md-7">
                    <div class="contact-info-section margin-40px-tb">
                        <ul class="list-style9 no-margin">
                            <li>
                                <div class="row" fxFlexAlign="start center">
                                    <div class="col-md-5 col-5" fxLayout="column">
                                        <strong>{{'AVANCES.TITULOS.NAME' | translate}}</strong>
                                    </div>
                                    <div class="col-md-7 col-7" fxLayout="column">
                                        <p>{{name}}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="row" fxFlexAlign="start center">
                                    <div class="col-md-5 col-5" fxLayout="column">
                                        <strong>{{'AVANCES.TITULOS.ESTADOS' | translate}}</strong>
                                    </div>
                                    <div class="col-md-7 col-7" fxLayout="column">
                                        <p>{{status | translate}}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="row" fxFlexAlign="start center">
                                    <div class="col-md-5 col-5" fxLayout="column">
                                        <strong>{{'AVANCES.TITULOS.FECHA1' | translate}}</strong>
                                    </div>
                                    <div class="col-md-7 col-7" fxLayout="column">
                                        <p>{{fechaInicio}}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="row" fxFlexAlign="start center">
                                    <div class="col-md-5 col-5" fxLayout="column">
                                        <strong>{{'AVANCES.TITULOS.FECHA2' | translate}}</strong>
                                    </div>
                                    <div class="col-md-7 col-7" fxLayout="column">
                                        <p>{{fechaFin}}</p>
                                    </div>
                                </div>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>


        </ng-container>
    </div>
</div>